import { Col, Collapse, Input, Radio, Row, Select, Slider, Checkbox, Tag } from "antd";
import React, { useState } from "react";
import arrowDownIcon from "../../assets/images/arrow-down.png";
import sortIcon from "../../assets/images/sort-icon.png";
import SimpleCard from "../../components/simpleCard/SimpleCard";
import Title from "../../components/typography/title/Title";
import { CloseOutlined, FilterOutlined } from "@ant-design/icons";
import "./style.css";
import { colorHexMap } from "../../view/colorlibrarygarments";


const ProductsWithFiltersBrand = ({ data, handleColorClick,subCategoryName }) => {
  const { Search } = Input;
  const { Panel } = Collapse;


  

  // State for filters
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState([]);
  const [selectedSize, setSelectedSize] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedPriceRange, setSelectedPriceRange] = useState([0, 1000000]);
  const [selectedFit, setSelectedFit] = useState([]);
  const [selectedWeight, setSelectedWeight] = useState([]);
  const [selectedSleeveLength, setSelectedSleeveLength] = useState([]);
  const [selectedAge, setSelectedAge] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // For search functionality
  const [sortOrder, setSortOrder] = useState(null); // For sorting functionality
  const [showAllMaterial, setShowAllMaterial] = useState(false);
const [showAllSize, setShowAllSize] = useState(false);
const [showAllBrand, setShowAllBrand] = useState(false);
const [showAllFit, setShowAllFit] = useState(false);
const [showAllWeight, setShowAllWeight] = useState(false);
const [showAllSleeve, setShowAllSleeve] = useState(false);
const [showAllColor, setShowAllColor] = useState(false);




  // State to control sidebar visibility
  const [sidebar, setSidebar] = useState(false);

  // Extract unique filter options based on the data
  const availableColors = [...new Set(data.flatMap((product) => product.colors || []))];
  const availableMaterials = [...new Set(data.map((product) => product.material))];
  const availableSizes = [...new Set(data.flatMap((product) => product.size.split(',').map((s) => s.trim())))];
  const availableBrands = [...new Set(data.map((product) => product.brand))];
  const availableFits = [...new Set(data.map((product) => product.fit))];
  const availableWeights = [...new Set(data.map((product) => product.weight))];
  const availableSleeveLengths = ["Short Sleeve", "Long Sleeve"];
  const availableAges = ["Adult", "Youth"];

  // Handle filter changes
  const onColorChange = (color) => {
    setSelectedColors((prevColors) =>
      prevColors.includes(color) ? prevColors.filter((c) => c !== color) : [...prevColors, color]
    );
  };

const onMaterialChange = (materials) => {
  setSelectedMaterial(materials);
};


  const onSizeChange = (size) => {
    setSelectedSize(size);
  };

  const onBrandChange = (brand) => {
    setSelectedBrand(brand);
  };

  const onPriceChange = (value) => {
    setSelectedPriceRange(value);
  };

  const onFitChange = (fit) => {
    setSelectedFit(fit);
  };

  const onWeightChange = (weight) => {
    setSelectedWeight(weight);
  };

  const onSleeveLengthChange = (length) => {
    setSelectedSleeveLength(length);
  };

  const onAgeChange = (age) => {
    setSelectedAge(age);
  };

  // Handle search term change
  const onSearch = (value) => {
    setSearchTerm(value.toLowerCase());
  };

  // Handle sorting by price
  const onSortChange = (value) => {
    setSortOrder(value);
  };

  // Remove filter and reset its state in the sidebar
  const removeFilter = (filterType) => {
    switch (filterType) {
      case 'color':
        setSelectedColors([]);
        break;
      case 'material':
        setSelectedMaterial([]);
        break;
case 'size':
  setSelectedSize([]);
  break;

      case 'brand':
        setSelectedBrand([]);
        break;
      case 'fit':
        setSelectedFit([]);
        break;
      case 'weight':
        setSelectedWeight([]);
        break;
      case 'sleeveLength':
        setSelectedSleeveLength([]);
        break;
      case 'age':
        setSelectedAge(null);
        break;
      default:
        break;
    }
  };

  // Filter the products based on selected criteria and search term
  let filteredProducts = data.filter((product) => {
    const matchesColor = selectedColors.length === 0 || selectedColors.some((color) => product.colors.includes(color));

    const matchesMaterial = selectedMaterial.length === 0 || selectedMaterial.includes(product.material);
   const matchesSize = selectedSize.length === 0 || selectedSize.some(size => product.size.split(',').map(s => s.trim()).includes(size));
const matchesBrand = selectedBrand.length === 0 || selectedBrand.includes(product.brand);
const matchesFit = selectedFit.length === 0 || selectedFit.includes(product.fit);
const matchesWeight = selectedWeight.length === 0 || selectedWeight.includes(product.weight);
const matchesSleeveLength = selectedSleeveLength.length === 0 || selectedSleeveLength.includes(product.sleeveLength);

    const matchesPrice = product.price >= selectedPriceRange[0] && product.price <= selectedPriceRange[1];

    const matchesAge = !selectedAge || product.age === selectedAge;
    const matchesSearchTerm = product.title.toLowerCase().includes(searchTerm);

    return (
      matchesColor &&
      matchesMaterial &&
      matchesSize &&
      matchesBrand &&
      matchesPrice &&
      matchesFit &&
      matchesWeight &&
      matchesSleeveLength &&
      matchesAge &&
      matchesSearchTerm
    );
  });

  // Sort the products based on selected sort order (low to high or high to low)
  if (sortOrder === "low_to_high") {
    filteredProducts = filteredProducts.sort((a, b) => a.price - b.price);
  } else if (sortOrder === "high_to_low") {
    filteredProducts = filteredProducts.sort((a, b) => b.price - a.price);
  }


console.log("subCategoryName",subCategoryName);

  return (
    <div className="productsWithFilters">
      <Row className="page-header">
        <Col className="title-section" md={24}>
          <Title size={"41"} weight={700} tag={"h1"}>
             {subCategoryName}
          </Title>
          <Title customClass={"sub-title"} size={"21"} weight={500} tag={"h5"}>
            Design your  {subCategoryName} online with fast and free shipping
          </Title>
        </Col>
      </Row>

    

      <Row align={"middle"} className="header-row">
        <Col  md={5} className="d-desktop">
          <Title size={"26"} weight={400} tag={"h3"}>
            Available options
          </Title>
        </Col>
        <Col xs={24} md={24} lg={6} className="d-mobile">
          <button onClick={() => setSidebar(!sidebar)} className="filter-btn">
            <Title size={"26"} weight={400} tag={"h3"}>
              Filters
            </Title>
            <FilterOutlined />
          </button>
        </Col>
        <Col xs={24} md={24} lg={19}>
          <Row justify={"space-between"} align={"middle"}>
            <Col xs={24} md={24} lg={17}>
              <div className="search-container">
                <Title size={"20"} weight={400} tag={"h3"}>
                  {`Showing <span class="title fw-700"> ${filteredProducts.length} </span> products`}
                </Title>
                <Search className="custom-search" placeholder="Search" onSearch={onSearch} />
              </div>
            </Col>
            <Col xs={24} md={6}>
              <div className="sorting-container">
                <div className="image-container">
                  <img src={sortIcon} alt="sort-icon" className="sort-icon" />
                  <Title size={"20"} weight={400} tag={"h3"}>
                    Sort:
                  </Title>
                </div>
                <Select
                  suffixIcon={<img src={arrowDownIcon} alt="search-icon" />}
                  className="custom-select"
                  showSearch
                  placeholder="Sort by"
                  onChange={onSortChange}
                  options={[
                    { value: "popular", label: "Most Popular" },
                    { value: "low_to_high", label: "Price: Low to High" },
                    { value: "high_to_low", label: "Price: High to Low" },
                  ]}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="filter-content">
        <Col xs={24} md={5} className={`filter-sidebar ${sidebar ? "show" : ""}`}>
          <div className="d-mobile sidebar-close-btn">
            <CloseOutlined onClick={() => setSidebar(false)} />
          </div>
          <Collapse expandIconPosition="end" className="filters" defaultActiveKey={['1','2','3','4','5','6','7','8','9']}>

{availableColors.length > 0 && (
  <Panel header="Color" key="1">
    <div className="colors-container filter-color colorcontainer-start">
      {(showAllColor ? availableColors : availableColors.slice(0, 18)).map((colorName, index) => {
        const colorHex = colorHexMap[colorName]?.hex || "#ffffff";
        const isSelected = selectedColors.includes(colorName);
        return (
          <Checkbox
            key={index}
            checked={isSelected}
            onChange={() => onColorChange(colorName)}
            className="color-checkbox"
          >
            <div
              className={`color-bo color-box-two ${isSelected ? 'selectedcolorfilter' : ''}`}
              style={{ backgroundColor: colorHex, position: 'relative' }}
            >
              {isSelected && (
                <span
                  style={{
                    position: 'absolute',
                    top: '-6px',
                    right: '2px',
           
                    // borderRadius: '50%',
                    padding: '2px',
             
             
                    color: '#ffffff',
                    fontSize:'30px',
                    fontWeight: 'bold',
                  }}
                >

                  <svg enable-background="new 0 0 24 24" height="7" viewBox="0 0 24 24" width="7" xmlns="http://www.w3.org/2000/svg"><path d="m12 0c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12z" fill="#fff"/><path fill="#a1a1a1" d="m12 24c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12zm0-22.5c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5z"/></svg>
  
            {/* <svg height="7px" viewBox="0 0 496 496" width="7px" xmlns="http://www.w3.org/2000/svg"><path d="m488 248c0 132.546875-107.453125 240-240 240s-240-107.453125-240-240 107.453125-240 240-240 240 107.453125 240 240zm0 0" fill="#fff"/><path d="m248 496c-136.964844 0-248-111.035156-248-248s111.035156-248 248-248 248 111.035156 248 248c-.160156 136.902344-111.097656 247.839844-248 248zm0-480c-128.128906 0-232 103.871094-232 232s103.871094 232 232 232 232-103.871094 232-232c-.140625-128.070312-103.929688-231.859375-232-232zm0 0" fill="#a1a1a1"/></svg> */}
                </span>
              )}
            </div>
          </Checkbox>
        );
      })}
    </div>
    {availableColors.length > 8 && (
      <button className="show-more-btn" onClick={() => setShowAllColor(!showAllColor)}>
        {showAllColor ? 'Show Less' : 'Show More'}
      </button>
    )}
  </Panel>
)}






            <Panel header="Price" key="2">
              <Slider range marks={{ 0: "$5", 100: "$490" }} value={selectedPriceRange} onChange={onPriceChange} />
            </Panel>

{availableMaterials.length > 0 && (
  <Panel header="Material" key="3">
    <Checkbox.Group onChange={onMaterialChange} value={selectedMaterial}style={{ display: 'flex',flexDirection:'column',rowGap:'8px' }}>
      {(showAllMaterial ? availableMaterials : availableMaterials.slice(0, 8)).map((material, index) => (
        <Checkbox key={index} value={material}>
          {material}
        </Checkbox>
      ))}
    </Checkbox.Group>
    {availableMaterials.length > 8 && (
      <button className="show-more-btn" onClick={() => setShowAllMaterial(!showAllMaterial)}>
        {showAllMaterial ? 'Show Less' : 'Show More'}
      </button>
    )}
  </Panel>
)}


{availableSizes.length > 0 && (
  <Panel header="Size" key="4">
    <Checkbox.Group value={selectedSize} onChange={onSizeChange}style={{ display: 'flex',flexDirection:'column',rowGap:'8px' }}>
      {(showAllSize ? availableSizes : availableSizes.slice(0, 8)).map((size, index) => (
        <Checkbox key={index} value={size}>
          {size}
        </Checkbox>
      ))}
    </Checkbox.Group>
    {availableSizes.length > 8 && (
      <button className="show-more-btn" onClick={() => setShowAllSize(!showAllSize)}>
        {showAllSize ? 'Show Less' : 'Show More'}
      </button>
    )}
  </Panel>
)}


{availableBrands.length > 0 && (
  <Panel header="Brand" key="5">
    <Checkbox.Group value={selectedBrand} onChange={onBrandChange}style={{ display: 'flex',flexDirection:'column',rowGap:'8px' }}>
      {(showAllBrand ? availableBrands : availableBrands.slice(0, 8)).map((brand, index) => (
        <Checkbox key={index} value={brand}>
          {brand}
        </Checkbox>
      ))}
    </Checkbox.Group>
    {availableBrands.length > 8 && (
      <button className="show-more-btn" onClick={() => setShowAllBrand(!showAllBrand)}>
        {showAllBrand ? 'Show Less' : 'Show More'}
      </button>
    )}
  </Panel>
)}



{availableFits.length > 0 && (
  <Panel header="Fit" key="6">
    <Checkbox.Group value={selectedFit} onChange={onFitChange}style={{ display: 'flex',flexDirection:'column',rowGap:'8px' }}>
      {(showAllFit ? availableFits : availableFits.slice(0, 8)).map((fit, index) => (
        <Checkbox key={index} value={fit}>
          {fit}
        </Checkbox>
      ))}
    </Checkbox.Group>
    {availableFits.length > 8 && (
      <button className="show-more-btn" onClick={() => setShowAllFit(!showAllFit)}>
        {showAllFit ? 'Show Less' : 'Show More'}
      </button>
    )}
  </Panel>
)}



{availableWeights.length > 0 && (
  <Panel header="Weight" key="7">
    <Checkbox.Group value={selectedWeight} onChange={onWeightChange}style={{ display: 'flex',flexDirection:'column',rowGap:'8px' }}>
      {(showAllWeight ? availableWeights : availableWeights.slice(0, 8)).map((weight, index) => (
        <Checkbox key={index} value={weight} >
          {weight}
        </Checkbox>
      ))}
    </Checkbox.Group>
    {availableWeights.length > 8 && (
      <button className="show-more-btn" onClick={() => setShowAllWeight(!showAllWeight)}>
        {showAllWeight ? 'Show Less' : 'Show More'}
      </button>
    )}
  </Panel>
)}


{availableSleeveLengths.length > 0 && (
  <Panel header="Sleeve Length/Style" key="8">
    <Checkbox.Group value={selectedSleeveLength} onChange={onSleeveLengthChange}style={{ display: 'flex',flexDirection:'column',rowGap:'8px' }}>
      {availableSleeveLengths.map((length, index) => (
        <Checkbox key={index} value={length}>
          {length}
        </Checkbox>
      ))}
    </Checkbox.Group>
  </Panel>
)}


            {availableAges.length > 0 && (
              <Panel header="Age" key="9">
                <Radio.Group onChange={onAgeChange} value={selectedAge}>
                  {availableAges.map((age, index) => (
                    <Radio key={index} value={age}>
                      {age}
                    </Radio>
                  ))}
                </Radio.Group>
              </Panel>
            )}
          </Collapse>
        </Col>

        <Col md={24} lg={19}>
          {/* Display Active Filters */}
      <Row className="active-filtersss">
        {selectedColors.length > 0 && (
          <Tag closable onClose={() => removeFilter('color')}>
            Colors: {selectedColors.join(", ")}
          </Tag>
        )}
        {selectedMaterial.length > 0 && (
          <Tag closable onClose={() => removeFilter('material')}>
            Material: {selectedMaterial}
          </Tag>
        )}
        {selectedSize.length > 0 && (
          <Tag closable onClose={() => removeFilter('size')}>
            Size: {selectedSize}
          </Tag>
        )}
        {selectedBrand.length > 0 && (
          <Tag closable onClose={() => removeFilter('brand')}>
            Brand: {selectedBrand}
          </Tag>
        )}
        {selectedFit.length > 0 && (
          <Tag closable onClose={() => removeFilter('fit')}>
            Fit: {selectedFit}
          </Tag>
        )}
        {selectedWeight.length > 0 && (
          <Tag closable onClose={() => removeFilter('weight')}>
            Weight: {selectedWeight}
          </Tag>
        )}
        {selectedSleeveLength.length > 0 && (
          <Tag closable onClose={() => removeFilter('sleeveLength')}>
            Sleeve Length: {selectedSleeveLength}
          </Tag>
        )}
        {selectedAge && (
          <Tag closable onClose={() => removeFilter('age')}>
            Age: {selectedAge}
          </Tag>
        )}
      </Row>
      <Row className="productListing" gutter={[10, 10]}>
  {filteredProducts.map((item, index) => (
    <Col xs={12} sm={12} md={12} lg={12} xl={8} key={index}>
      <SimpleCard cardType={"filterCard"} data={item}  colors={item.colors} handleColorClick={handleColorClick}/>
    </Col>
  ))}
</Row>

        </Col>
      </Row>
    </div>
  );
};

export default ProductsWithFiltersBrand;
